var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-5dcb2c7b-eb00-4844-9554-ba9038423971",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .uuid-b4e4cd52-b833-4f2e-a861-54e68e389eb7 {\n        fill: #f2f2f2;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "uuid-b4e4cd52-b833-4f2e-a861-54e68e389eb7",
    d: "M21.97,20.34c-.27,0-.55-.11-.75-.33l-5.23-5.84-5.23,5.84c-.37.41-1,.45-1.41.08-.41-.37-.45-1-.08-1.41l5.97-6.68c.38-.42,1.11-.42,1.49,0l5.97,6.68c.37.41.33,1.04-.08,1.41-.19.17-.43.25-.67.25Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUp);
export default __webpack_public_path__ + "static/media/Up.aae54a8df836eabcc57e9091bf2b3c60.svg";
export { ForwardRef as ReactComponent };